module.exports = __webpack_public_path__ + "img/end_point.a78d6165.svg";